import React from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Bars/Sidebar";
import LoginPage from "../pages/Login/LoginPage";

const ProtectedRoutes = () => {
    const navigate = useNavigate();
    const [login, setLogin] = React.useState(!!localStorage.getItem("token"));

    const handleLogin = () => {
        setLogin(true);
        navigate("/"); // optional: redirect after login
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        setLogin(false);      // update state to show login page
        navigate("/login");   // redirect to login page
    };

    return (
        <>
            {login ? <Sidebar onLogout={handleLogout} /> : <LoginPage onLogin={handleLogin} />}
        </>
    );
};

export default ProtectedRoutes;
